import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { Loader2 } from "lucide-react";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import ProtectedRoute from "@/components/ProtectedRoute";

import Login from "@/pages/admin/Login";
import Dashboard from "@/pages/admin/Dashboard";
import DashboardEntry from "@/pages/admin/DashboardEntry";
import Fundstuecke from "@/pages/admin/Fundstuecke";
import NewItem from "@/pages/admin/NewItem";
import EditItem from "@/pages/admin/EditItem";
import Inquiries from "@/pages/admin/Inquiries";
import Batch from "@/pages/admin/Batch";
import Benutzer from "@/pages/admin/Benutzer";
import Aktivitaet from "@/pages/admin/Aktivitaet";
import Oeffnungszeiten from "@/pages/admin/Oeffnungszeiten";
import Sicherheit from "@/pages/admin/Sicherheit";
import MeinBrocki from "@/pages/admin/MeinBrocki";
import PlanNutzung from "@/pages/admin/PlanNutzung";
import BilderGalerie from "@/pages/admin/BilderGalerie";
import StorageOptimierung from "@/pages/admin/StorageOptimierung";
import SupportEnter from "@/pages/admin/SupportEnter";
import Claim from "@/pages/Claim";
import SuperAdmin from "@/pages/admin/SuperAdmin";
import PlattformKonten from "@/pages/admin/PlattformKonten";
import Services from "@/pages/admin/Services";
import AktionenNews from "@/pages/admin/AktionenNews";
import Bewertungen from "@/pages/admin/Bewertungen";
import AboRechnungen from "@/pages/admin/AboRechnungen";

function RootRedirect() {
  const { user } = useAuth();
  if (user === null) {
    return (
      <div className="dark flex min-h-screen items-center justify-center bg-fundio-dark">
        <Loader2 className="h-8 w-8 animate-spin text-fundio-gold" />
      </div>
    );
  }
  return <Navigate to={user ? "/dashboard" : "/login"} replace />;
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<RootRedirect />} />
            <Route path="/login" element={<Login />} />
            <Route path="/support" element={<SupportEnter />} />
            <Route path="/claim/:token" element={<Claim />} />
            <Route path="/dashboard" element={<ProtectedRoute><DashboardEntry /></ProtectedRoute>} />
            <Route path="/dashboard/mein-brocki" element={<ProtectedRoute><MeinBrocki /></ProtectedRoute>} />
            <Route path="/dashboard/fundstuecke" element={<ProtectedRoute><Fundstuecke /></ProtectedRoute>} />
            <Route path="/dashboard/neu" element={<ProtectedRoute><NewItem /></ProtectedRoute>} />
            <Route path="/dashboard/batch" element={<ProtectedRoute><Batch /></ProtectedRoute>} />
            <Route path="/dashboard/fundstuecke/:id/bearbeiten" element={<ProtectedRoute><EditItem /></ProtectedRoute>} />
            <Route path="/dashboard/anfragen" element={<ProtectedRoute><Inquiries /></ProtectedRoute>} />
            <Route path="/dashboard/services" element={<ProtectedRoute><Services /></ProtectedRoute>} />
            <Route path="/dashboard/aktionen" element={<ProtectedRoute><AktionenNews /></ProtectedRoute>} />
            <Route path="/dashboard/bewertungen" element={<ProtectedRoute><Bewertungen /></ProtectedRoute>} />
            <Route path="/dashboard/abo" element={<ProtectedRoute><AboRechnungen /></ProtectedRoute>} />
            <Route path="/dashboard/oeffnungszeiten" element={<ProtectedRoute><Oeffnungszeiten /></ProtectedRoute>} />
            <Route path="/dashboard/plan" element={<ProtectedRoute><PlanNutzung /></ProtectedRoute>} />
            <Route path="/dashboard/galerie" element={<ProtectedRoute><BilderGalerie /></ProtectedRoute>} />
            <Route path="/dashboard/optimierung" element={<ProtectedRoute><StorageOptimierung /></ProtectedRoute>} />
            <Route path="/dashboard/sicherheit" element={<ProtectedRoute><Sicherheit /></ProtectedRoute>} />
            <Route path="/dashboard/einstellungen" element={<Navigate to="/dashboard/sicherheit" replace />} />
            <Route path="/dashboard/benutzer" element={<ProtectedRoute><Benutzer /></ProtectedRoute>} />
            <Route path="/dashboard/aktivitaet" element={<ProtectedRoute><Aktivitaet /></ProtectedRoute>} />
            <Route path="/dashboard/super-admin" element={<ProtectedRoute><SuperAdmin /></ProtectedRoute>} />
            <Route path="/dashboard/plattform-konten" element={<ProtectedRoute><PlattformKonten /></ProtectedRoute>} />
            <Route path="*" element={<RootRedirect />} />
          </Routes>
        </BrowserRouter>
        <Toaster position="top-center" richColors />
      </AuthProvider>
    </div>
  );
}

export default App;
